import { render, staticRenderFns } from "./MfmCard.vue?vue&type=template&id=dfd3126a&scoped=true"
import script from "./MfmCard.vue?vue&type=script&lang=js"
export * from "./MfmCard.vue?vue&type=script&lang=js"
import style0 from "./MfmCard.vue?vue&type=style&index=0&id=dfd3126a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd3126a",
  null
  
)

export default component.exports